module.exports = __webpack_public_path__ + "static/media/33.97c401f5.png";